import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../lib/cn.js';
const TONES = {
    success: 'bg-success-surface text-success border-success/20',
    warning: 'bg-warning-surface text-warning border-warning/20',
    danger: 'bg-danger-surface text-danger border-danger/20',
    info: 'bg-info-surface text-info border-info/20',
    neutral: 'bg-surface-sunken text-content-muted border-border',
};
export function Pill({ tone = 'neutral', children, className, }) {
    return (_jsx("span", { className: cn('inline-flex items-center gap-1 whitespace-nowrap rounded-full border px-2.5 py-0.5', 'text-xs font-medium', TONES[tone], className), children: children }));
}
//# sourceMappingURL=pill.js.map